import React, { useState } from 'react';
import { TrackByPath } from '../SiteHeaderTracking.js';
import { useAppState } from '../AppStateContext.tsx';
import { SiteHeaderNavigation } from './SiteHeaderNavigation.jsx';

export const SiteHeaderDesktopNavigation = ({ navigation }) => {
  const {
    isMenuVisible,
    selectedMenu,
    setSelectedMenu,
    setMenuLevel,
    setIsMenuVisible,
    setSelectedCategory,
    setSelectedProductSection,
  } = useAppState();
  const showMenu = (navigationItem) => {
    setSelectedMenu(navigationItem);
    setIsMenuVisible(true);
    setSelectedCategory(null);
    setSelectedProductSection(null);
    setMenuLevel(2);
  };
  return (
    <nav className={`primaryDesktopNavigation d-none d-lg-flex${isMenuVisible ? ' navigation-open' : ''}`}>
      <div aria-hidden="true" className={`primaryDesktopNavigation-menu ${isMenuVisible ? ' active' : ''}`}></div>
      <ul>
        {navigation &&
          navigation.map((navigationItem, i) => (
            <li key={i}>
              {navigationItem?.Link ? (
                <a
                  onClick={() => {
                    TrackByPath(navigationItem.EnglishTitle);
                  }}
                  className={`navigationItem navigationHeading firstLevelMenuItem`}
                  href={navigationItem.Link}
                >
                  {navigationItem.Title}
                </a>
              ) : (
                <>
                  <button
                    onClick={() => {
                      if (navigationItem == selectedMenu) {
                        setIsMenuVisible(false);
                        setSelectedCategory(null);
                        setSelectedProductSection(null);
                        setMenuLevel(1);
                      } else {
                        showMenu(navigationItem);
                      }
                    }}
                    className={`firstLevelMenuItem btn navigation__item ${selectedMenu == navigationItem && 'active'}`}
                    aria-expanded={selectedMenu == navigationItem}
                    aria-controls={`navigation-item-${i}`}
                    aria-label={`${selectedMenu == navigationItem ? 'Close' : 'Open'} menu ${navigationItem.Title}`}
                  >
                    <span className="navigationHeading">{navigationItem.Title}</span>
                  </button>
                  <SiteHeaderNavigation
                    navItem={navigationItem}
                    id={`navigation-item-${i}`}
                    index={i}
                    isActive={selectedMenu == navigationItem}
                    isMobile={false}
                  />
                </>
              )}
            </li>
          ))}
      </ul>
    </nav>
  );
};
